module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Dislike-dded2ab0931d93bf434d3e340647a12d.svg";